var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeechbubbleLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99809 0H14L13.9982 13.9959C11.937 13.9959 10.0578 13.2166 8.6394 11.9366C4.6787 14.1886 0 13.9959 0 13.9959C0 13.9959 5.86235 10.0891 5.99809 2.27559V0Z",
    fill: "black",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99811 0H5.99809V2.27559C5.90254 7.77548 2.96965 11.3397 1.24113 12.9683C0.513999 13.6534 0 13.9959 0 13.9959C0 13.9959 0.646028 14.0225 1.66118 13.9404C3.37796 13.8015 6.15045 13.3518 8.6394 11.9366C10.0578 13.2166 11.937 13.9959 13.9982 13.9959V12.9962C12.194 12.9962 10.5513 12.3151 9.30948 11.1945L8.77311 10.7105L8.14501 11.0676C6.35368 12.0861 4.37782 12.5757 2.80079 12.8057C3.10645 12.4695 3.42532 12.091 3.7448 11.6701C5.32262 9.59118 6.92555 6.46081 6.99796 2.29294L6.99811 0Z",
    fill: "white",
    fillOpacity: 0.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechbubbleLeft);
export default __webpack_public_path__ + "static/media/speechbubble_left.de72e8da12cded16432f5cd3c0b5655a.svg";
export { ForwardRef as ReactComponent };